export default __webpack_public_path__ + "static/media/nfcc_menu_logo.43c862dd.png";